import React, { useEffect, useState } from "react";

import "./SwitchButton.css";

function SwitchButtonDark({ isActive, filterSwitch, small = false, onClick }) {
  const [active, setActive] = useState();
  const activeClassName = active ? `on` : "off";

  const handleSwitch = () => {
    onClick && onClick();
    setActive(!active);
  };

  useEffect(() => {
    setActive(isActive);
  }, [isActive]);

  return (
    <button
      className={`switchButton switch-button-dark ${activeClassName} ${
        filterSwitch ? " filterSwitchButton" : "switchButton"
      }`}
      style={{
        "--filterSwitchBtnColor": `${active ? "#e3e3e3" : "#59a8c4"}`,
        minWidth: "31px",
        backgroundColor: active ? "#59a8c4" : "#e3e3e3",
      }}
      onClick={handleSwitch}
    >
      <div
        className={`${filterSwitch ? " filterSwitchCircle" : "switchCircle"} `}
        style={{
          "--filterSwitchCircleColor": `${small ? "#59a8c4" : "#e3e3e3"}`,
        }}
      ></div>
    </button>
  );
}

export default SwitchButtonDark;
